<template>
  <div
    v-if="open"
    class="report-overlay"
    @click.self="$emit('close')"
  >
    <div
      class="report-overlay__dialog"
      :class="`report-overlay__dialog--${size}`"
      role="dialog"
      aria-modal="true"
      :aria-labelledby="titleId"
    >
      <div class="report-overlay__header">
        <slot name="header">
          <h2
            :id="titleId"
            class="report-overlay__title"
          >
            {{ title }}
          </h2>
        </slot>
        <button
          type="button"
          class="report-overlay__close"
          aria-label="Close"
          @click="$emit('close')"
        >
          ×
        </button>
      </div>
      <div class="report-overlay__body">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
let titleUid = 0;

export default {
  name: 'ReportOverlayDialog',
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'lg',
      validator: (v) => [ 'md', 'lg' ].includes(v),
    },
  },
  emits: ['close'],
  data() {
    titleUid += 1;
    return {
      titleId: `report-overlay-title-${titleUid}`,
    };
  },
};
</script>

<style>
.report-overlay {
  position: fixed;
  inset: 0;
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: rgba(49, 51, 63, 0.6);
}

.report-overlay__dialog {
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 0.5rem;
  box-shadow: 0 0.25rem 1.25rem rgba(49, 51, 63, 0.28);
  overflow: hidden;
  font-family: Roobert-Regular, 'Segoe UI', Arial, sans-serif;
  color: #31333f;
  max-height: min(85vh, 900px);
}

.report-overlay__dialog--lg {
  width: min(1152px, 92vw);
}

.report-overlay__dialog--md {
  width: min(720px, 92vw);
  max-height: min(85vh, 800px);
}

.report-overlay__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #d6d9e0;
  flex-shrink: 0;
}

.report-overlay__title {
  margin: 0;
  font-family: Roobert-Semi-Bold, Roobert-Regular, 'Segoe UI', Arial, sans-serif !important;
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1.3;
  color: #31333f;
}

.report-overlay__close {
  border: none;
  background: transparent;
  color: #31333f;
  opacity: 0.55;
  font-size: 1.75rem;
  line-height: 1;
  padding: 0 0.15rem;
  cursor: pointer;
}

.report-overlay__close:hover {
  opacity: 1;
}

.report-overlay__body {
  padding: 1.25rem 1.5rem 1.75rem;
  overflow: auto;
  font-size: 1rem;
  line-height: 1.6;
}

.report-overlay__body p {
  margin: 0 0 1rem;
  font-family: Roobert-Regular, 'Segoe UI', Arial, sans-serif !important;
}

.report-overlay__body p:last-child {
  margin-bottom: 0;
}

.report-overlay__body strong {
  font-family: Roobert-Semi-Bold, Roobert-Regular, 'Segoe UI', Arial, sans-serif !important;
  font-weight: 600;
}

.report-overlay__body em {
  font-style: italic;
}
</style>
